import { Skeleton } from '@chakra-ui/react';
import { Card, CardBody, CardHeader } from 'ui-components';
import { convertPxToRems } from '~/utils-ts';

export const SkeletonCard = () => {
  return (
    <Card minWidth={convertPxToRems(300)} pointerEvents="none">
      <CardHeader
        paddingBottom={convertPxToRems(10)}
        width={convertPxToRems(132)}
      >
        <Skeleton height={convertPxToRems(12)} startColor="primary.50" />
      </CardHeader>
      <CardBody>
        <Skeleton
          width="100%"
          maxWidth={convertPxToRems(84)}
          height={convertPxToRems(40)}
          startColor="primary.50"
        />
      </CardBody>
    </Card>
  );
};
